import { EventBuzz } from '@/main'

const toggleNoMargin = state => EventBuzz.$emit('toggle-no-margin', state)

export default {
    mounted() {
        toggleNoMargin(true)
    },
    destroyed() {
        toggleNoMargin(false)
    },
}
